import * as React from "react";
const SvgContest = (props) => (
  <svg
    width={21}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g
      style={{
        mixBlendMode: "multiply",
      }}
    >
      <path
        d="M15.25 3.334h-.833V2.5a.833.833 0 1 0-1.667 0v.834h-5V2.5a.833.833 0 1 0-1.667 0v.834H5.25a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5ZM5.25 5h.833v.834a.833.833 0 0 0 1.667 0V5h5v.834a.833.833 0 1 0 1.667 0V5h.833a.833.833 0 0 1 .833.834v3.333H4.417V5.834A.833.833 0 0 1 5.25 5Zm10 11.667h-10a.833.833 0 0 1-.833-.833v-5h11.666v5a.834.834 0 0 1-.833.833Z"
        fill="#121212"
      />
      <path
        d="M6.917 14.167a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM13.583 12.5h-3.334a.833.833 0 0 0 0 1.667h3.334a.833.833 0 1 0 0-1.667Z"
        fill="#000"
      />
    </g>
  </svg>
);
export default SvgContest;
